import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet } from 'api-service';
import { ignoreRequestParams } from 'utils';
import { adaptNssIndex, adaptNssTrend } from './netSentimentScore.adapter';

const SEARCH_PATH = '/search/api/v1/search';

export const getNetSentimentScore = createAsyncThunk(
  'netSentimentScoreSlice/getNetSentimentScore',
  async ({ apiPath, params }, thunkAPI) => {
    try {
      const response = await apiGet(
        SEARCH_PATH,
        ignoreRequestParams({ ...params, api_path: `${apiPath}/nss` })
      );

      return adaptNssIndex(response?.data?.result?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getNetSentimentScoreTrend = createAsyncThunk(
  'netSentimentScoreSlice/getNetSentimentScoreTrend',
  async ({ apiPath, params, timeGap }, thunkAPI) => {
    try {
      const response = await apiGet(
        SEARCH_PATH,
        ignoreRequestParams({
          ...params,
          api_path: `${apiPath}/nss/chart`,
          time_gap: timeGap,
        })
      );

      return adaptNssTrend(response?.data?.result?.data, timeGap);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
